
import { useTranslation } from "react-i18next";
import image from '../../img/ProductsArvest/img3.png';

const Active = () => {
    const { t } = useTranslation();
    return (
        <section className="relative open-sans md:pt-[90px] xl:pt-[160px]">
            <div className="relative z-10 max-w-[1220px] xl:mx-auto mx-[20px]">
                <div className="flex md:flex-row flex-col-reverse justify-between gap-[30px]">
                    <div className="max-w-[473px] pb-[30px]">
                        <h2 className="max-w-[390px] sm:text-[19px] font-[700] text-[14px] text-[#0C2780]">
                            {t('productsarvest.3')}
                        </h2>
                        <p className="sm:text-[16px] font-[300] text-[14px] text-[#0C2780] sm:my-[15px] my-[13px]">
                            {t('productsarvest.4')}
                        </p>
                        <p className="sm:text-[16px] font-[300] text-[14px] text-[#0C2780]">
                            {t('productsarvest.5')}
                        </p>
                    </div>
                    <div className="flex-shrink-0 lg:w-[407px] md:w-[50%] md:max-w-[407px] sm:w-[100%] w-[calc(100%+40px)] sm:ml-0 ml-[-20px] md:h-auto h-[200px]">
                        <img className="w-full h-full object-cover object-center" src={image} alt='' />
                    </div>
                </div>
                <div className="md:grid grid-cols-2 md:w-full w-[calc(100%+40px)] ml-[-20px] md:ml-0">
                    <div className="bg-[#FFF] md:px-[30px] px-[20px] md:py-[60px] py-[30px]">
                        <h4 className="sm:text-[19px] font-[700] text-[14px] text-[#0C2780]">
                            {t('productsarvest.6')}
                        </h4>
                        <p className="max-w-[473px] sm:text-[16px] font-[300] text-[14px] text-[#0C2780] sm:mt-[15px] mt-[13px]">
                            {t('productsarvest.7')}
                        </p>
                        <p className="max-w-[473px] sm:text-[16px] font-[300] text-[14px] text-[#0C2780] sm:mt-[15px] mt-[13px]">
                            {t('productsarvest.8')}
                        </p>
                    </div>
                    <div className="bg-[#5191E8] md:px-[30px] px-[20px] md:py-[60px] py-[30px]">
                        <h4 className="sm:text-[19px] font-[700] text-[14px] text-[#FFF]">
                            {t('productsarvest.9')}
                        </h4>
                        <p className="max-w-[473px] sm:text-[16px] font-[300] text-[14px] text-[#FFF] sm:mt-[15px] mt-[13px]">
                            {t('productsarvest.10')}
                        </p>
                    </div>
                </div>
            </div>
        </section>
    )
};

export default Active;
